import { Dialog } from 'quasar';

export default function open(component: object, config: object) {
  return Dialog.create({
    component,
    ...config,
  });
}
